import { gql } from '@apollo/client';

export const BOOKMARK_FRAGMENT = gql`
  fragment Bookmark on Document {
    key
    name
    uri
    folders {
      key
    }
  }
`;